import "./tags.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.function.name");

var _Link = _interopRequireDefault(require("../Link"));

var _component = require("../../_utils/component.js");

var _data = require("../data.js");

var _vueNormalizeComponent = _interopRequireDefault(require("../../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('template-tags'),
  components: {
    GDLink: _Link.default
  },
  mixins: [_component.componentMixin],
  props: {
    list: {
      type: Array,
      required: true
    },
    filter: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      tabKey: 1,
      categories: _data.categories
    };
  },

  methods: {
    changeKey(key) {
      this.tabKey = key;
    },

    onClick(item) {
      this.$emit('click', item);
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem()
  }, _vm._l(_vm.list, function (item) {
    return _c("GDLink", {
      key: item.id,
      class: _vm.bem("tag"),
      attrs: {
        url: {
          path: _vm.filter === "q" ? "/templates?q=" + item.name : "/templates/" + _vm.filter + item.id
        }
      },
      nativeOn: {
        click: function click($event) {
          return _vm.onClick(item);
        }
      }
    }, [_vm._v("\n\n        " + _vm._s(item.name) + "\n\n    ")]);
  }), 1);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;